import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogTitle from "@mui/material/DialogTitle"
import { useLogoutMutation } from "@store/services/authService"
import logger from "@utils/logger"

type LogoutDialogProps = {
  open: boolean
  setOpen: (value: ((prevState: boolean) => boolean) | boolean) => void
  onAcceptClick: () => void
}

export default function LogoutDialog({ open, setOpen, onAcceptClick }: LogoutDialogProps) {
  const [doLogout, { isLoading: isLogoutLoading }] = useLogoutMutation()

  const handleClose = () => {
    setOpen(false)
  }

  const handleLogout = React.useCallback(async () => {
    try {
      await doLogout().unwrap()
    } catch (error: unknown) {
      logger.error("Unhandled exception when sending logout ping to backend", error)
    }

    onAcceptClick()
  }, [doLogout, onAcceptClick])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Are you sure you want to log out?"}</DialogTitle>
      <DialogActions>
        <Button onClick={handleClose} variant={"contained"} disabled={isLogoutLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleLogout}
          color={"error"}
          autoFocus={true}
          variant={"contained"}
          disabled={isLogoutLoading}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  )
}
